import { render } from "./filePreviewComp.vue?vue&type=template&id=5b471130"
import script from "./filePreviewComp.vue?vue&type=script&lang=js"
export * from "./filePreviewComp.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__